// src/services/cmiService.js
import axios from "axios";

/**
 * ✅ Base serveur (sans /api) — pas d'URL en dur dans le code
 * CRA :  REACT_APP_API_BASE_URL=http://localhost:4000
 * Vite:  VITE_API_BASE_URL=http://localhost:4000
 */
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "https://nouzhaback-theta.vercel.app";

/**
 * ✅ Instance axios dédiée au CMI
 * (CMI renvoie du HTML => responseType: "text")
 */
const cmiClient = axios.create({
  baseURL: `${API_BASE}/api/cmi`,
  withCredentials: true,
  headers: { "Content-Type": "application/json", Accept: "text/html" },
  responseType: "text",
  transformResponse: [(r) => r], // IMPORTANT: garder le HTML tel quel
});

const cmiService = {
  /**
   * Crée un paiement CMI pour un séjour (hôtel).
   * Backend: POST /api/cmi/hotel/create
   * Retour: HTML (<form> + auto-submit)
   */
  async createHotelPayment(payload) {
    const res = await cmiClient.post("/hotel/create", payload);
    return res.data; // string HTML
  },

  /**
   * Crée un paiement CMI pour un circuit touristique.
   * Backend: POST /api/cmi/circuit/create
   * Retour: HTML (<form> + auto-submit)
   */
  async createCircuitPayment(payload) {
    const res = await cmiClient.post("/circuit/create", payload);
    return res.data;
  },

  /**
   * Crée un paiement CMI pour un transport touristique.
   * Backend: POST /api/cmi/transport/create
   * Retour: HTML (<form> + auto-submit)
   */
  async createTransportPayment(payload) {
    const res = await cmiClient.post("/transport/create", payload);
    return res.data;
  },

  /**
   * Crée un paiement CMI pour une visite guidée.
   * Backend: POST /api/cmi/visite/create
   * Retour: HTML (<form> + auto-submit)
   */
  async createVisitePayment(payload) {
    const res = await cmiClient.post("/visite/create", payload);
    return res.data;
  },

  /**
   * Crée un paiement CMI pour une location de voiture.
   * Backend: POST /api/cmi/voiture/create
   * Retour: HTML (<form> + auto-submit)
   */
  async createVoiturePayment(payload) {
    const res = await cmiClient.post("/voiture/create", payload);
    return res.data;
  },
};

export default cmiService;
